import React from 'react';
import Select from 'react-select';

function SelectControl({
    value,
    options,
    onChange,
    placeholder = 'Select...',
    isClearable = false,
    isDisabled = false,
    menuPortalTarget = typeof document !== 'undefined' ? document.body : null,
}) {
    const styles = {
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        control: (base) => ({
            ...base,
            minHeight: 38,
            borderColor: '#ced4da',
        }),
    };

    return (
        <Select
            value={options.find(o => String(o.value) === String(value)) || null}
            options={options}
            onChange={(opt) => onChange(opt ? String(opt.value) : '')}
            placeholder={placeholder}
            isClearable={isClearable}
            isDisabled={isDisabled}
            isSearchable
            menuPortalTarget={menuPortalTarget}
            styles={styles}
            classNamePrefix="rs"
        />
    );
}

export default SelectControl;
